import { useAccounts } from "@/controllers/gridManager/accountsManager/accountManager"
import { getViewFullInfoByAccountId } from "@/utilities"
import { FormControl, Select, MenuItem, SelectChangeEvent, useTheme } from "@mui/material"

type Props = {
    currentAccountId: any,
    handleChangeAccount: (event: SelectChangeEvent) => void
    fullWidth?: boolean
    isFilter?: boolean
}

export default function AccountSelector({ currentAccountId, handleChangeAccount, fullWidth, isFilter }: Props) {
    const theme = useTheme()
    const { accounts } = useAccounts()

    const filterAccount = accounts.filter((item: any) => {
        return (isFilter === true ? (item?.cdcontent === '09') : (item?.cdcontent !== '09'))
    })

    return (
        <FormControl fullWidth={fullWidth ?? true} >
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={currentAccountId}
                size='small'
                label="currentAccountId"
                sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, background: theme.palette.background.input }}
                onChange={handleChangeAccount}
            >
                {
                    filterAccount.map((subAccount: any, index: number) => {
                        return <MenuItem key={index} value={subAccount.acctno}>{getViewFullInfoByAccountId(subAccount.acctno)}</MenuItem>
                    })
                }
            </Select>
        </FormControl>
    )
}